import spinner from '../assets/svg/spinner.svg'

const Loader = () => {
  return (
    <div className="flex justify-center items-center z-index-90">
        <div>
            <img src={spinner} alt="loading..." className='h-[80px] w-[80px]' />
        </div>
    </div>
  )
}

export default Loader